const _apibase = "https://apiv4.kiuruvesi.net/";
const _cockpit = "https://gvk.cloud2.kanakori.fi/api/";
const _demoads = [
  {
    priority_date: new Date().toISOString(),
    title: "Mainoksen cta-line",
    cta_text: "Osta",
    cta_link: "https://kanakori.fi"
  },
  {
    priority_date: new Date().toISOString(),
    title: "Klikaa tästä hurja tarjous!",
    cta_text: "Klikaa tästä",
    cta_link: "https://kanakori.fi"
  }
];

function _toHumanDate(inp) {
  function __a(date) {
    const daysShort = ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"];
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1);
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const dateOb = new Date(date);

    let prefix;
    if (dateOb.toDateString() === now.toDateString()) {
      prefix = "Tänään";
    }
    if (dateOb.toDateString() === tomorrow.toDateString()) {
      prefix = "Huomenna";
    }
    if (dateOb.toDateString() === yesterday.toDateString()) {
      prefix = "Eilen";
    }

    return prefix
      ? `${prefix} ${dateOb.getDate()}.${dateOb.getMonth() + 1} (${daysShort[
          dateOb.getDay()
        ].toLowerCase()})`
      : `${dateOb.getDate()}.${dateOb.getMonth() + 1}${
          dateOb.getFullYear() === tomorrow.getFullYear()
            ? ""
            : "." + dateOb.getFullYear()
        } (${daysShort[dateOb.getDay()].toLowerCase()})`;
  }

  return __a(inp);
}
function _autoProcess(inp) {
  // Käänteinen järjestys pvm mukaan
  inp.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });

  // Poistaa liian vanhat
  inp = inp.filter(item => {
    if (
      new Date(item.date).getTime() >
      new Date(Date.now() - 864e5) /* Eilen */ - 10000000
    ) {
      return true;
    }
  });

  // Järjestys oikein päin
  inp.sort((a, b) => {
    return new Date(a.date) - new Date(b.date);
  });

  // poistetaan liian uudet
  inp.length = Math.min(inp.length, 7);

  // Lisätään humandate
  for (let i = 0; i < inp.length; i++) {
    const item = inp[i];
    item.humandate = _toHumanDate(item.date);
  }

  return inp;
}

export default {
  _toHumanDate,
  _autoProcess,
  getFoods(list, mode = "current") {
    return new Promise((resolve, reject) => {
      switch (mode) {
        case "current":
          fetch(`${_apibase}list${list}?key=rNKuNrc6H9NtuQEh`)
            .then(res => res.json())
            .then(res => {
              console.log(res);
              if (Array.isArray(res) && _autoProcess(res).length > 0) {
                if (
                  Math.random() > 0.2 ||
                  process.env.NODE_ENV === "production"
                )
                  resolve(_autoProcess(res));
                else reject(new Error("Simulated error"));
              } else {
                throw new Error(
                  "Listaa ei voi näyttää juuri nyt. Kokeile uudelleen myöhemmin!"
                );
              }
            })
            .catch(e => reject(e));
          break;
        default:
          reject(new Error("[getFoods] Invalid mode"));
          break;
      }
    });
  },

  getAds() {
    return new Promise((resolve, reject) => {
      fetch(`${_cockpit}collections/get/Kaupalliset`)
        .then(res => res.json())
        .then(res => {
          console.log(res.entries);
          console.log(_demoads);
          if (Array.isArray(res.entries) && res.entries.length > 0) {
            if (Math.random() > 0.2 || process.env.NODE_ENV === "production")
              resolve(res.entries);
            else reject(new Error("Simulated error"));
          } else {
            throw new Error("Can't load ads");
          }
        })
        .catch(e => reject(e));
    });
  },

  getListinfos() {
    return new Promise((resolve, reject) => {
      fetch(`${_apibase}listinfos?key=rNKuNrc6H9NtuQEh`)
        .then(res => res.json())
        .then(res => {
          console.log(res);
          if (Array.isArray(res) && res.length > 0) {
            resolve(res);
          } else {
            reject(new Error("No results from query"));
          }
        })
        .catch(e => reject(e));
    });
  },

  buyProducts(products, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.webdriver ? cb() : errorCb();
    }, 100);
  }
};
